import { collection, onSnapshot, query, where } from "firebase/firestore";
import { useEffect, useState } from "react";
import { database } from "../firebase";

export default function useDatabase(collectionName, uid, category) {
  const [docs, setDocs] = useState([]);
  let filter_uid = "";
  let filter_category = "";

  if (uid) {
    filter_uid = "==";
    filter_category = "!=";
  } else {
    filter_uid = "!=";
    filter_category = "==";
  }

  useEffect(() => {
    const q = query(
      collection(database, collectionName),
      where("uid", filter_uid, String(uid)),
      where("category", filter_category, category)
    );

    const unsub = onSnapshot(q, (snapshot) => {
      let docs = [];
      snapshot.forEach((doc) => {
        docs.push({ ...doc.data(), id: doc.id });
      });

      //sessionStorage.setItem("query", JSON.stringify(docs));

      setDocs(docs);
    });

    return () => unsub();
  }, [collectionName, uid, filter_uid, category, filter_category]);

  return { docs };
}
